import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class DailyPlanService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetTopBar(data) {
        return this.http.post('/api/DailyPlan/TopBar', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetDetailsFilters(data) {
        return this.http.post('/api/DailyPlan/Location/FilterBar', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetStatistics(data) {
        return this.http.post('/api/DailyPlan/Statistics', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetDetailsStatistics(data) {
        return this.http.post('/api/DailyPlan/Location/Statistics', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetBreadcrumb(data) {
        return this.http.post('/api/DailyPlan/Location/Breadcrumb', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetTiles(data) {
        return this.http.post('/api/DailyPlan/Tiles', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetDetailsTiles(data) {
        return this.http.post('/api/DailyPlan/Location/Tiles', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetResourcePool(data) {
        return this.http.post('/api/DailyPlan/ResourcePool', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetResourcePoolFilters(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/FilterBar', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    BorrowAction(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/BorrowAction', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomBreadcrumb(data) {
        return this.http.post('/api/DailyPlan/Room/Breadcrumb', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomDetails(data) {
        return this.http.post('/api/DailyPlan/Room/Details', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomActivities(data) {
        return this.http.post('/api/DailyPlan/Room/Activities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    RescheduleNonDailyActivities(data) {
        return this.http.post('/api/DailyPlan/RescheduleNonDailyActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetNonDailyActivities(data) {
        return this.http.post('/api/DailyPlan/NonDailyActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SaveRoomActivities(data) {
        return this.http.post('/api/DailyPlan/Room/EditDuration', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ResetLocationActivities(data) {
        return this.http.post('/api/DailyPlan/Room/ResetActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetOtherActivities(data) {
        return this.http.post('/api/DailyPlan/Location/OtherActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetQCCheckActivities(data) {
        return this.http.post('/api/DailyPlan/Location/QcCheckActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }
    
    SetGridRowActions(data) {
        return this.http.post('/api/DailyPlan/Room/ActivityAction', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomInformation(data) {
        return this.http.post('/api/DailyPlan/Room/Information', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SaveRoomInformation(data) {
        return this.http.post('/api/DailyPlan/Room/SaveInformation', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ChangeSequence(data) {
        return this.http.post<string>('/api/DailyPlan/DragActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragIntoResourcePool(data) {
        return this.http.post('/api/DailyPlan/DragIntoResourcePool', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToActivitiesGrid(data) {
        return this.http.post('/api/DailyPlan/DragOntoActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToActivitiesGridRow(data) {
        return this.http.post('/api/DailyPlan/DragOntoActivitiesRow', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToOtherActivitiesLocation(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToOtherActivitiesGridGroup(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivitiesGroup', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToOtherActivitiesGridRow(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivitiesRow', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToQCActivitiesLocation(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToQCActivitiesGridGroup(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivitiesGroup', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    DragFromResourcePoolToQCActivitiesGridRow(data) {
        return this.http.post('/api/DailyPlan/DragOntoOtherActivitiesRow', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    LoadStaffActivities(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/StaffSchedule', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    UpdateStaff(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/EditStaffSchedule', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SetShiftStartTime(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/EditShiftTime', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    EmergencyData() {
        return this.http.post('/api/DailyPlan/Tiles', { data: new Date(), unitId: 481 }).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    EditStaffNotes(data) {
        return this.http.post('/api/DailyPlan/ResourcePool/EditStaffNotes', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
